import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAccessibleModuleTiles } from '../../../hooks/useAccessibleModuleTiles';
import { HomeReveal } from './HomeMotion';

function readSignedIn() {
  const rememberMe = localStorage.getItem('rememberMe') === 'true';
  let accessToken = null;

  if (rememberMe) {
    accessToken = localStorage.getItem('accessToken');
  } else {
    accessToken = sessionStorage.getItem('accessToken');
    const tempAccessToken = localStorage.getItem('tempAccessToken');
    if (tempAccessToken) {
      accessToken = tempAccessToken;
    }
  }

  return Boolean(accessToken && localStorage.getItem('user'));
}

const HomeTrustBar = () => {
  const [signedIn, setSignedIn] = useState(readSignedIn);
  const { tiles, loading } = useAccessibleModuleTiles(signedIn);

  useEffect(() => {
    const sync = () => setSignedIn(readSignedIn());
    window.addEventListener('storage', sync);
    window.addEventListener('user-logged-in', sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('user-logged-in', sync);
    };
  }, []);

  if (!signedIn) return null;

  return (
    <HomeReveal as="section" className="home-trust" aria-label="Your modules">
      <div className="home-container">
        {loading && tiles.length === 0 ? (
          <p className="home-trust-loading">Loading modules…</p>
        ) : (
          <nav className="home-trust-modules">
            {tiles.map((tile) => (
              <Link
                key={tile.key}
                to={tile.to}
                className={`home-trust-module${tile.locked ? ' is-locked' : ''}`}
                title={
                  tile.locked
                    ? 'This module is not available in your current subscription plan.'
                    : tile.title
                }
              >
                <span className="home-trust-module__icon">
                  {tile.iconStyle || (
                    <i className={tile.iconClass} aria-hidden="true" />
                  )}
                  {tile.locked ? (
                    <i
                      className="fas fa-lock home-trust-module__lock"
                      aria-hidden="true"
                    />
                  ) : null}
                </span>
                <span className="home-trust-module__name">{tile.title}</span>
              </Link>
            ))}
          </nav>
        )}
      </div>
    </HomeReveal>
  );
};

export default HomeTrustBar;
